import React, { useEffect, useRef, useState } from "react";
import { FaTelegramPlane, FaArrowRight, FaArrowLeft } from "react-icons/fa";
import "./carouselads.css";

const adsData = [
  { id: 1, text: "Grow Your Brand", imgSrc: "/assets/image1.webp", link: "#" },
  { id: 2, text: "Reach More Customers", imgSrc: "/assets/image2.jpg", link: "#" },
  { id: 3, text: "Boost Your Sales", imgSrc: "/assets/image3.webp", link: "#" },
  { id: 4, text: "Connect with Audience", imgSrc: "/assets/image4.jpg", link: "#" },
  { id: 5, text: "Maximize Your Impact", imgSrc: "/assets/image5.jpg", link: "#" },
  
];

const TRANSITION_MS = 900;
const telegramAd = { link: "https://t.me/IklimDigitals" };


export default function CarouselAds() {
  const [itemsToShow, setItemsToShow] = useState(3);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [transitionEnabled, setTransitionEnabled] = useState(true);

  const wrapperRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  /** Detect screen width and set items to show */
  useEffect(() => {
    const updateLayout = () => {
      const w = window.innerWidth;
      if (w <= 576) {
        setItemsToShow(1);
      } else if (w <= 992) {
        setItemsToShow(2);
      } else {
        setItemsToShow(3);
      }
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  /** Reset index when layout changes */
  useEffect(() => {
    setTransitionEnabled(false);
    setCurrentIndex(0);
    const t = setTimeout(() => setTransitionEnabled(true), 50);
    return () => clearTimeout(t);
  }, [itemsToShow]);

  // Create clones for a seamless infinite loop effect on all screen sizes
  const extendedAds = [...adsData, ...adsData.slice(0, itemsToShow)];

  /** Auto-play for desktop/tablet */
  useEffect(() => {
    // Disable auto-play on mobile (itemsToShow === 1) or when hovered
    if (itemsToShow === 1 || isHovered) return;
    const id = setInterval(() => setCurrentIndex((p) => p + 1), 5000);
    return () => clearInterval(id);
  }, [isHovered, itemsToShow]);

  /** Reset when looping reaches clone slides */
  useEffect(() => {
    if (currentIndex >= adsData.length) {
      const t = setTimeout(() => {
        setTransitionEnabled(false);
        setCurrentIndex(0);
        setTimeout(() => setTransitionEnabled(true), 50);
      }, TRANSITION_MS);
      return () => clearTimeout(t);
    }
  }, [currentIndex, itemsToShow]);

  const nextSlide = () => {
    setTransitionEnabled(true);
    setCurrentIndex((p) => p + 1);
  };

  const prevSlide = () => {
    setTransitionEnabled(true);
    if (currentIndex === 0) {
      // For instant jump-back to allow previous
      setTransitionEnabled(false);
      setCurrentIndex(adsData.length); // Jump to the start of the clones
      setTimeout(() => {
        setTransitionEnabled(true);
        setCurrentIndex(adsData.length - 1);
      }, 50);
    } else {
      setCurrentIndex((p) => p - 1);
    }
  };

  /** Swipe gestures */
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchEndX.current = e.touches[0].clientX; // Reset endX
  };
  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const dist = touchStartX.current - touchEndX.current;
    if (dist > 50) nextSlide();
    if (dist < -50) prevSlide();
  };

  const itemWidth = 100 / itemsToShow;
  const wrapperWidth = (extendedAds.length / itemsToShow) * 100;
  const transformX = (currentIndex * itemWidth * itemsToShow) / extendedAds.length;

  const wrapperStyle = {
    transform: `translateX(-${transformX}%)`,
    width: `${wrapperWidth}%`,
    transition: transitionEnabled
      ? `transform ${TRANSITION_MS}ms cubic-bezier(.22,.95,.14,1)`
      : "none",
  };

  return (
    <section className="carouselads-section">
      <div
        className="ads-container"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <button className="nav-arrow left-arrow" onClick={prevSlide} aria-label="Previous">
          <FaArrowLeft />
        </button>

        <div className="ads-viewport">
          <div className="ads-wrapper" ref={wrapperRef} style={wrapperStyle}>
            {extendedAds.map((ad, idx) => (
              <article
                className="ad-item"
                key={`${ad.id}-${idx}`}
                style={{ flexBasis: `calc(100% / ${extendedAds.length})` }}
              >
                <a href={telegramAd.link} className="ad-image-wrap"   target="_blank"
    rel="noopener noreferrer">
                  <img className="ad-image" src={ad.imgSrc} alt={ad.text} />
                </a>
                <div className="ad-body">
                  <h4 className="ad-title">{ad.text}</h4>
                  <div className="ad-actions">
  <FaTelegramPlane className="telegram-icon" aria-hidden="true" />
  <a
    href={telegramAd.link}
    className="join-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    Join Us
  </a>
</div>

                </div>
              </article>
            ))}
          </div>
        </div>

        <button className="nav-arrow right-arrow" onClick={nextSlide} aria-label="Next">
          <FaArrowRight />
        </button>
      </div>

      <div className="carousel-dots">
        {adsData.map((_, i) => {
          const activeIndex = currentIndex % adsData.length;
          return (
            <button
              key={i}
              className={`dot ${i === activeIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          );
        })}
      </div>
    </section>
  );
}